import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {StorageService} from '@services/storage.service';
import {UserService} from '@services/user.service';

@Component({
	selector: 'app-remove-account',
	templateUrl: './remove-account.component.html',
	styleUrls: ['./remove-account.component.scss']
})
export class RemoveAccountComponent implements OnInit {

	@Input() email: string = '';

	public error: string = '';
	public password: string = '';

	/**
	 * If data is loading
	 */
	public isLoading: boolean = false;

	/**
	 * Constructor
	 * @param activeModal {NgbActiveModal} Current modal
	 * @param storageService
	 * @param userService
	 */
	constructor(public activeModal: NgbActiveModal,
				public storageService: StorageService,
				public userService: UserService) {
	}

	ngOnInit(): void {
	}

	/**
	 * Update emmail
	 */
	async validate() {
		this.error = '';
		this.isLoading = true;
		try {
			const ret = await this.userService.removeAccount(this.email, this.password);
			if (ret.error) {
				return this.error = ret.message;
			}
			this.userService.logout();
			window.location.href = '/';
			this.activeModal.close(true);
		} catch (e) {
			this.error = 'unknow';
		}
		this.isLoading = false;
	}

	/**
	 * Close the modal
	 */
	close() {
		this.activeModal.close(false);
	}

}
